import React from 'react';

interface EnvironmentBannerProps {
    environment: string | undefined;
}

export const EnvironmentBanner: React.FC<EnvironmentBannerProps> = ({ environment }) => {
    const label = environment?.trim() ?? '';

    if (label === '' || label.toLowerCase() === 'production') {
        return null;
    }

    return (
        <div
            role="status"
            data-env-banner
            className="sticky top-0 z-99998 h-(--env-banner-height) flex items-center justify-center bg-mp-error text-mp-error-content text-xs font-bold tracking-wider uppercase"
        >
            {label.toUpperCase()} ENVIRONMENT
        </div>
    );
};
